export default __webpack_public_path__ + "static/media/Jefferson_Lab.82c4d8c2.png";